import { plainNumber, priceDigit } from 'scripts';

export function __irtToFixed(symbol: string, value?: number | string) {
    if (symbol === 'IRT') {
        return priceDigit(parseFloat(plainNumber(value?.toString()) ?? '0').toFixed(0));
    }
    return priceDigit(value);
}
